export const RB_DATA_FETCHING = "RB_DATA_FETCHING";
export const RB_DATA_FETCHED = "RB_DATA_FETCHED";
export const RB_DATA_FETCHING_FAILED = "RB_DATA_FETCHING_FAILED";

export const RB_REPORT_FETCHING = "RB_REPORT_FETCHING";
export const RB_REPORT_FETCHED = "RB_REPORT_FETCHED";
export const RB_REPORT_FETCHING_FAILED = "RB_REPORT_FETCHING_FAILED";

export const RB_DATA_STATE_ADD = "RB_DATA_STATE_ADD";
export const RB_DATA_STATE_REMOVE = "RB_DATA_STATE_REMOVE";

export const RB_LOT_DATA = "RB_LOT_DATA";
export const RB_TEST_NAME_FETCHED = "RB_TEST_NAME_FETCHED";
export const RB_TEST_NAME_FETCHING = "RB_TEST_NAME_FETCHING";
export const RB_TEST_NAME_FETCHING_FAILED = "RB_TEST_NAME_FETCHING_FAILED";

export const RB_TEST_NAME = "RB_TEST_NAME";
export const RB_FROM_DATE = "RB_FROM_DATE";
export const RB_TO_DATE = "RB_TO_DATE";

export const RB_CONFIG_FAILED = "RB_CONFIG_FAILED";
export const RB_CONFIG_FETCHED = "RB_CONFIG_FETCHED";
export const RB_CONFIG_FETCHING = "RB_CONFIG_FETCHING";


export const RB_LOT_SELECTED = "RB_LOT_SELECTED";
export const RB_REAGENT_NAME_SELECTED = "RB_REAGENT_NAME_SELECTED";